export { default, SendToDoctorFormValues } from "./SendToDoctorForm";
